export default __webpack_public_path__ + "static/media/station-clock-out.71f4b9f9.png";